export const isEqualPointPosition = (
  a?: naver.maps.Point,
  b?: naver.maps.Point
) => {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  }

  a = new window.naver.maps.LatLng(a.x, a.y);
  b = new window.naver.maps.LatLng(b.x, b.y);

  return a.equals(b);
};

export const isEqualPositionTransform = (
  a?: {x?: string; y?: string},
  b?: {
    x?: string;
    y?: string;
  }
) => {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  }

  return JSON.stringify(a) === JSON.stringify(b);
};
